<div>
        <div class="patient-card-with-form">
          @if (bannerData != undefined) {
            <app-resource-banner [bannerJson]="bannerData" (patientResult)="getBannerData($event)" (footerLinksClick)="bannerLinks($event);">
            </app-resource-banner>
          }
        </div>
</div>
<div class="row">
  @if (!utilService.isMobile() && !f_type) {
    <div class="page-title-container d-flex">
      <div class="page-title flex-grow-1 ">
        <div class="mb-0 ">
          <div class="d-flex align-items-center">
            <div class="pl-2 pr-2 ">
              <a class="d-inline-flex" href="javascript:void(0)" (click)="listResource()">
                <img src="assets/images/grid-back.png"></a>
              </div>
              <div class="">{{pageTitleKey | translate | async }} </div>
            </div>
          </div>
        </div>
        <div class="component-container "></div>
      </div>
    }
    @if (resourceDef != undefined && resourceDef.form) {
      <div class="col-sm-12">
        <!-- {{dialogConfig.data|json}} -->
        <dhs-form #formComponenet (getData)="getDataFn($event)" [action]="formAction" [config]="config"
          [data]="formData"
          [fieldGroup]="resourceDef.form" [decorator]="dec_p" (saveFinished)="onSaveFinished($event)"
          (questionValueChanged)="questionValueChanged($event)" [customButton]="isView ? undefined : btn">
        </dhs-form>
      </div>
    }
      <!-- <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mt-4">
        <button type="button" class="primary-btn" (click)="createBill('createBill')">
          Submit
          <i aria-hidden="true" class="fa fa-save ml-2"></i>
        </button>
      </div> -->

  </div>